<script setup lang="ts">
import { RouteName } from "@/App/router/routeName";
import { windowsService } from "@/App/services/windowsService";
import { useFeedbackStore } from "@/App/stores";
import { useUserStore } from "@/App/user/user.store";
import { useNavbarStore } from "./navigation.store";

const userStore = useUserStore();
const feedbackStore = useFeedbackStore();
const navbarStore = useNavbarStore();

const onHelpClick = (): void => {
  windowsService.openInNewWindow("https://twiage.helpsite.com");
};

const onProductGuideClick = (): void => {
  navbarStore.openProductGuide();
};
</script>
<template>
  <li>
    <p aria-hidden="true" role="button" class="dropdown-item" @click="onProductGuideClick">Product Guide</p>
  </li>
  <li hidden="true">
    <p
      aria-hidden="true"
      title="What's New"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasDashboardWhatsNew"
      aria-controls="offcanvasDashboardWhatsNew"
      class="dropdown-item"
    >
      What's New
    </p>
  </li>
  <li>
    <p
      class="dropdown-item"
      aria-hidden="true"
      title="Options"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasDeshboardOptions"
      aria-controls="offcanvasDeshboardOptions"
    >
      Options
    </p>
  </li>
  <li id="feedback-link" @click="feedbackStore.open()">
    <p class="dropdown-item" aria-hidden="true" title="Options">Feedback</p>
  </li>
  <li>
    <p class="dropdown-item" @click="onHelpClick">Help</p>
  </li>
  <hr />
  <li>
    <RouterLink class="dropdown-item" :to="RouteName.login" @click="userStore.logout">Logout</RouterLink>
  </li>
</template>

<style scoped>
.dropdown-item {
  cursor: pointer;
}

#feedback-link {
  display: none;
}

@media (max-width: 767px) {
  #feedback-link {
    display: block;
  }
}
</style>
